import React from "react";
import BarraInferior from "./components/BarraInferior";
import EmbedContent from "./components/EmbedContent";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

import axios from "axios";

import { isMobileOnly } from "react-device-detect";

import "./App.css";
import autorizados from "./autorizados.json";
library.add(faSpinner);

class App extends React.Component {
	constructor(props) {
		super(props);
		let dominio = "";
		if (document.referrer) {
			dominio = document.referrer.split("//")[1].split("/")[0];
			console.log(dominio);
		}

		let showBar = true;
		autorizados.forEach(nombre => {
			if (dominio.includes(nombre)) {
				showBar = false;
			}
		});
		if (isMobileOnly) {
			showBar = false;
		}

		this.state = {
			title: "",
			slug: window.location.pathname.split("/")[
				window.location.pathname.split("/").length - 1
			],
			type: "",
			url: "",
			canonical: "",
			fetching: true,
			available: true,
			showBar
		};
	}
	componentDidMount() {
		if (this.state.slug !== "") {
			axios
				.get(
					`${
						process.env.REACT_APP_DEV === "true"
							? `https://dev.juegosjuegos.com`
							: ``
					}/api/gameInfo?slug=${this.state.slug}`
				)
				.then(response => {
					this.setState({ fetching: false, ...response.data });
				})
				.catch(err => {
					this.setState({ available: false, fetching: false });
				});
		} else {
			this.setState({
				fetching: false,
				available: false
			});
		}
	}
	render() {
		if (this.state.fetching) {
			return (
				<div className="App">
					<section className="Loading">
						<FontAwesomeIcon className="icon" icon="spinner" spin size="6x" />
					</section>
				</div>
			);
		}
		if (!this.state.available) {
			return (
				<div className="App">
					<section className="NotFound">
						<p>Game not Available</p>
					</section>
				</div>
			);
		}
		return (
			<div className={`App ${this.state.showBar ? "showBar" : ""}`}>
				<Helmet>
					<meta charSet="utf-8" />
					<title>{this.state.title}</title>
					<link rel="canonical" href={this.state.canonical} />
				</Helmet>
				<EmbedContent url={this.state.url} type={this.state.type} />
				{this.state.showBar ? (
					<BarraInferior
						title={this.state.title}
						canonical={this.state.canonical}
					/>
				) : null}
			</div>
		);
	}
}

export default App;
